import { EventFeedEvent } from '@toggle/toggle';
import React from 'react';

import { InsightsLivePrice } from '~/components/insights-live-price/InsightsLivePrice';
import { useEntities } from '~/react-query-hooks/entities/useEntities';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { getCardDate } from '~/utils/card-utils/card-utils';
import { CardPill } from '~/views/stream/components/stream-card/components/card-pill/CardPill';
import { useCatalystDrawer } from '~/widgets/catalyst-insights-drawer/useCatalystDrawer';
import { useMarketCatalystDrawer } from '~/widgets/market-catalyst-drawer/useMarketCatalystDrawer';

import * as S from '../../OverviewEventFeed.styles';
import { getCatalystEntityTag, parseCatalystData } from './utils';

export interface CatalystRowProps {
  event: EventFeedEvent;
  isLast?: boolean;
}

export const CatalystRow = ({ event, isLast }: CatalystRowProps) => {
  const { openDrawer: openCompanyCatalystDrawer } = useCatalystDrawer();
  const { openDrawer: openMarketCatalystDrawer } = useMarketCatalystDrawer();
  const { eventDate, isMarketWide, cardType, themeId, subCategory } =
    parseCatalystData(event);

  const entityTag = getCatalystEntityTag(event);

  const { data: entities } = useEntities({
    entityTags: entityTag ? [entityTag] : [],
    enabled: !!entityTag,
  });
  const entity = entities?.[0];

  const handleClick = () => {
    if (isMarketWide && subCategory) {
      openMarketCatalystDrawer({
        type: subCategory,
        themeId,
        insightId: event.source_id,
        source: POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      });
    } else {
      openCompanyCatalystDrawer({
        type: 'company',
        entityTag: event.entity,
        insightId: event.source_id,
        source: POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW,
      });
    }
  };

  return (
    <S.FeedItemWrapper $isLast={isLast}>
      <S.FeedItem onClick={handleClick}>
        <S.FeedItemHeader>
          <CardPill type={cardType} />
        </S.FeedItemHeader>
        <S.InsightTitle>{event.title}</S.InsightTitle>
        <S.StatsRow>
          <S.StatsContainer>
            {entity && (
              <InsightsLivePrice
                entity={entity}
                isHorizontalView
                showPricePercentage
                showDotSeparator
              />
            )}
          </S.StatsContainer>
          <S.TimeAgo>{getCardDate(eventDate)}</S.TimeAgo>
        </S.StatsRow>
      </S.FeedItem>
    </S.FeedItemWrapper>
  );
};
